export const changeCard = {
  'Almost there!': 'Falta pouco!',
  'Card change': 'Troca de cartão',
  'CARD NAME': 'NOME CARTÃO',
  expiry: 'vencimento',
  '{{name}}, to finalize the process, please provide a new credit card to avoid any headaches with future charges':
    '{{name}}, para finalizar o processo, por favor informe um novo cartão de crédito para evitar dor de cabeça com cobranças futuras',
};
